import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const ACTIVE_SHOPS_COLLECTION = 'active_shops';

export const saveLastSelectedShop = async (userId, shopData) => {
  try {
    if (!userId) throw new Error('User ID is required');
    
    const activeShopRef = doc(db, ACTIVE_SHOPS_COLLECTION, userId);
    await setDoc(activeShopRef, {
      shopData,
      updatedAt: new Date().toISOString()
    });

    return shopData;
  } catch (error) {
    console.error('Error saving last selected shop:', error);
    throw error;
  }
};

export const getLastSelectedShop = async (userId) => {
  try {
    if (!userId) return null;
    
    const activeShopRef = doc(db, ACTIVE_SHOPS_COLLECTION, userId);
    const activeShopDoc = await getDoc(activeShopRef);
    
    if (activeShopDoc.exists()) {
      const data = activeShopDoc.data();
      return data.shopData || null;
    }
    
    return null;
  } catch (error) {
    console.error('Error getting last selected shop:', error);
    return null;
  }
};
